import { CoursMarcheApi } from '@/api/cours-marche';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('cours-marche');

builder.addStatePart('marches', null, () => CoursMarcheApi.getValeurMarches(), 'SESSION', 1800);

const module = builder.build();
export default module;
